module.exports = __webpack_public_path__ + "static/media/boost_collection_img.5e2bd9b3.svg";